/**
 * 充电站数据层：对接后端 API（数据存储于 MySQL chargespot_db）
 * 管理操作（增/改/删）需携带管理员登录 token
 */
const BASE = '/api/stations'
const TOKEN_KEY = 'cs_admin_token'

function authHeaders() {
  const token = localStorage.getItem(TOKEN_KEY)
  return token ? { Authorization: 'Bearer ' + token } : {}
}

async function request(url, options) {
  const res = await fetch(url, {
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    ...options
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = new Error(data.error || `请求失败（${res.status}）`)
    err.status = res.status
    throw err
  }
  return data
}

// 查询全部站点（含分时价格），公开接口
export function listStations() {
  return request(BASE)
}

// 管理员登录
export function login({ username, password }) {
  return request('/api/admin/login', {
    method: 'POST',
    body: JSON.stringify({ username, password })
  })
}

// 新增站点（需登录）
export function addStation(form) {
  return request(BASE, {
    method: 'POST',
    body: JSON.stringify(form)
  })
}

// 编辑站点（需登录）
export function updateStation(id, form) {
  return request(`${BASE}/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(form)
  })
}

// 删除站点（需登录）
export function removeStation(id) {
  return request(`${BASE}/${encodeURIComponent(id)}`, { method: 'DELETE' })
}
